/* src/app/builder-screen-beta/inspector/inspector-flow-config.scss */
.flow-config-preview {
  margin-top: 12px;
  padding: 12px;
  background: #f5f5f5;
  border-radius: 4px;
  border-left: 3px solid #1890ff;
}
.flow-config-preview .preview-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.flow-config-preview .preview-item:last-child {
  margin-bottom: 0;
}
.flow-config-preview .preview-item .preview-label {
  font-weight: 500;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
}
.flow-config-preview .preview-item .preview-value {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.85);
  font-family: "Courier New", monospace;
  background: rgba(0, 0, 0, 0.04);
  padding: 2px 6px;
  border-radius: 2px;
}
.theme-alternate .flow-config-preview {
  background: #262626;
  border-left-color: #40a9ff;
}
.theme-alternate .flow-config-preview .preview-item .preview-label {
  color: rgba(255, 255, 255, 0.65);
}
.theme-alternate .flow-config-preview .preview-item .preview-value {
  color: rgba(255, 255, 255, 0.85);
  background: rgba(255, 255, 255, 0.08);
}
/*# sourceMappingURL=inspector-flow-config.css.map */
